import React from 'react'
import { Breadcrumb } from 'antd'
import { ComponentExt } from 'util/reactExt'
import { RouteComponentProps } from 'react-router'

interface IProps extends RouteComponentProps<any> {}
interface IState {}

export default class ActBreadCrumb extends ComponentExt<IProps, IState> {
  render() {
    const { breadCrumb, handleClickBreadCrumb }: any = this.props

    return (
      <>
        {breadCrumb && breadCrumb.length > 0 && (
          <Breadcrumb separator=">">
            {breadCrumb.map((itm, idx) => {
              return (
                <Breadcrumb.Item
                  onClick={() => handleClickBreadCrumb(itm.linkTo)}
                  key={idx}
                >
                  <a>{itm.text}</a>
                </Breadcrumb.Item>
              )
            })}
          </Breadcrumb>
        )}
      </>
    )
  }
}
